import { MapContainer, Marker, Popup, Tooltip } from "react-leaflet";
import { Tiles, dot, numPin, BR_CENTER } from "./mapParts";
import { ZoneLayers } from "./DeliveryMapEditor";
import { MovingMarker } from "@/components/tracking/MovingMarker";
import { courierIcon } from "@/components/tracking/TrackMap";
import { agoText } from "@/lib/tracking";
import { brl, fmtTime, PAY_LABELS } from "@/lib/api";

export const PIN_STATUS = [["recebido", "Recebido", "#f59e0b"], ["confirmado", "Confirmado", "#3b82f6"], ["preparo", "Em preparação", "#8b5cf6"], ["pronto", "Pronto", "#10b981"], ["entrega", "Saiu para entrega", "#ef4444"]];
const COLOR = Object.fromEntries(PIN_STATUS.map(([k, , c]) => [k, c]));
const LABEL = Object.fromEntries(PIN_STATUS.map(([k, l]) => [k, l]));

function OrderPopup({ o }) {
  const { lat, lng } = o.customer;
  return (
    <div className="space-y-1 text-xs" data-testid={`map-popup-${o.number}`}>
      <p className="text-sm font-bold">#{o.number} · {LABEL[o.status]}</p>
      <p className="font-semibold">{o.customer.name} {o.customer.phone}</p>
      <p>{o.customer.address}</p>
      {o.zone && <p>Área: {o.zone}</p>}
      <p>{brl(o.total)} · {PAY_LABELS[o.payment_method] || o.payment_method}{o.online?.status === "approved" ? " · PAGO ONLINE" : ""}</p>
      <p>Feito às {fmtTime(o.created_at)} · prazo {o.eta_minutes} min{o.courier ? ` · ${o.courier.name}` : ""}</p>
      <a href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`} target="_blank" rel="noreferrer" className="font-semibold underline">Abrir rota</a>
    </div>
  );
}

export function DeliveryOrdersMap({ settings, orders }) {
  const loc = settings.store_location || {};
  const store = loc.lat != null ? [loc.lat, loc.lng] : null;
  const open = orders.filter((o) => o.type === "delivery" && COLOR[o.status]);
  const pins = open.filter((o) => o.customer?.lat != null);
  const live = open.filter((o) => o.status === "entrega" && o.tracking?.lat != null);
  const center = store || (pins[0] ? [pins[0].customer.lat, pins[0].customer.lng] : BR_CENTER);
  return (
    <div className="space-y-3" data-testid="delivery-orders-map">
      <div className="flex flex-wrap items-center gap-3 text-xs">
        {PIN_STATUS.map(([k, l, c]) => <span key={k} className="flex items-center gap-1"><span className="h-3 w-3 rounded-full" style={{ background: c }} />{l}</span>)}
        <span className="flex items-center gap-1" data-testid="map-live-count"><span className="h-3 w-3 rounded-full border-2 border-white bg-blue-600" />Entregador ao vivo ({live.length})</span>
        <span className="ml-auto text-muted-foreground" data-testid="map-orders-count">{pins.length} de {open.length} entregas em aberto no mapa</span>
      </div>
      <div className="isolate overflow-hidden rounded-xl border">
        <MapContainer center={center} zoom={store || pins.length ? 13 : 4} className="h-[calc(100vh-280px)] min-h-[420px] w-full">
          <Tiles />
          <ZoneLayers center={store} radii={settings.delivery_radii || []} areas={settings.delivery_areas || []} />
          {store && <Marker position={store} icon={dot("#0f172a", 22)}><Tooltip direction="top">Loja</Tooltip></Marker>}
          {pins.map((o) => (
            <Marker key={o.id} position={[o.customer.lat, o.customer.lng]} icon={numPin(COLOR[o.status], `#${o.number}`)}>
              <Popup><OrderPopup o={o} /></Popup>
            </Marker>
          ))}
          {live.map((o) => (
            <MovingMarker key={`courier-${o.id}`} position={[o.tracking.lat, o.tracking.lng]} icon={courierIcon}>
              <Tooltip direction="top">#{o.number} · {o.courier?.name || "Entregador"} · {agoText(o.tracking.at)}</Tooltip>
            </MovingMarker>
          ))}
        </MapContainer>
      </div>
      {open.length > pins.length && <p className="text-xs text-muted-foreground">Pedidos sem localização (feitos sem localizar o endereço) aparecem só no quadro.</p>}
    </div>
  );
}
